export default __webpack_public_path__ + "static/Mobile-5ba5ba682709f170bddcd608decd84ba.jpg";